import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Workflow } from "lucide-react";
import api from "@/lib/api";

export const PlanToProcessButton = ({ projectId, source = "wbs" }) => {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const convert = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/processes/ai-from-plan", { project_id: projectId, name: "" }, { timeout: 120000 });
      toast.success(`"${data.name}" mapped with ${data.steps.length} steps — opening the Process page`);
      nav(`/projects/${projectId}?tab=process`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Maestro couldn't map the plan into a process — please try again");
    } finally { setBusy(false); }
  };

  return (
    <Button variant="outline" size="sm" className="gap-1.5" onClick={convert} disabled={busy}
      title={source === "flow" ? "Maestro maps this IO Flow into a process diagram on the Process page" : "Maestro maps this WBS into a process diagram on the Process page"}
      data-testid={source === "flow" ? "flow-to-process-button" : "wbs-to-process-button"}>
      {busy ? <><Loader2 className="h-3.5 w-3.5 animate-spin" /> Mapping…</> : <><Workflow className="h-3.5 w-3.5" /> Map to process</>}
    </Button>
  );
};

export default PlanToProcessButton;
